import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is cookie-only (httpOnly session cookie set by the backend).
// Clean up any legacy localStorage token from older builds.
try { localStorage.removeItem("vyrti_session_token"); } catch (e) { /* ignore */ }

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.dispatchEvent(new CustomEvent("vyrti:unauthorized"));
    }
    return Promise.reject(error);
  }
);

export function imgSrc(urlOrPath) {
  if (!urlOrPath) return "";
  if (urlOrPath.startsWith("http://") || urlOrPath.startsWith("https://")) return urlOrPath;
  if (urlOrPath.startsWith("/api/")) return `${BACKEND_URL}${urlOrPath}`;
  return urlOrPath;
}
